import { balanceDrug } from '../../api/balance'

export default {
    'entityName': 'balance',
    filterStorage: {},
    'pagination': {
      'itemsPerPage': 10,
      'page': 1,
      'sortBy': 'response_date',
      'descending': true
    },
    'fields': [
      {
        value: 'protocol_id',
        reference: 'protocol',
        text: 'Protocol',
        'type': 'autocomplete',
        mini: true,
        title: 'name'
      },
      {
        "value": "site_id",
        "reference": "protocol_has_site",
        "text": "Site",
        "type": "autocomplete",
        id: "site_id",
        small: true,
        title: 'site.name',
        subtitle: item => `${item.site.city} - ${item.site.code}`,
        readonly: item => !item.protocol_id,
        filter: (item, search) => {
            if (!search) {
                return  { protocol_id: item.protocol_id }
            }
            return { protocol_id: item.protocol_id, 'site.name': [{ 'site.name': `%${search}%`},
                {'site.city': `%${search}%`}, {'site.code': `%${search}%`}]}
        },
        deps: ['protocol_id'],
    },
      {
        value: 'drug_id',
        text: 'Drug',
        'type': 'autocomplete',
        id: 'drug.id',
        readonly: item => !item.protocol_id,
        list: balanceDrug,
        small: true,
        reference: 'balance',
        title: 'drug.name',
        subtitle: ({drug}) => drug.packaging !== 'Labels' ? `${drug.packaging}, ${drug.dose}${drug.measure_unit}` : `${drug.packaging} - ${drug.labels?.join(',')}`,
        deps: ['protocol_id', 'site_id'],
        validators: ['required']
      },
      {
        value: 'packaging',
        deps: ['drug_id'],
        visible: false,
        type: 'hidden',
        default: (item, args, selected) => selected?.drug.packaging
      },
      {
        mini: true,
        "value": "lotto",
        "text": "Batch number",
        id: 'lotto',
        reference: 'balance',
        "type": "autocomplete",
        title: 'lotto',
        subtitle: item => `${item.expiration} (${item.n_pieces})`,
        "table": {
            "sortable": true,
            "filter": true
        },
        filter: item => {
          if (!item.drug_id) return
            if (item.site_id) {
                return { protocol_id: item.protocol_id, drug_id: item.drug_id, site_id: item.site_id, place: 'SITE' }
            } else {
                return { protocol_id: item.protocol_id, drug_id: item.drug_id, place: 'STORAGE' }
            }
        },
        validators: [
          'required'
        ],
        default: () => '',
        visible: item => item.packaging !== 'Labels' && item.lotto !== '_labels',
        readonly: item => !item.drug_id,
        deps: ['protocol_id', 'site_id', 'drug_id'],
    },
    ],
  }
  